module.exports = __webpack_public_path__ + "img/hc_end_signup.477c3dec.png";